import SearchIcon from "@mui/icons-material/Search";
import { Box, IconButton, InputBase, Paper } from "@mui/material";
import React, { useRef } from "react";

function SearchInput({
  label,
  placeholder,
  value,
  onChange,
  onKeyDown,
  disabled,
  search,
  onClick,
}) {
  const inputRef = useRef(null);

  const handleClick = () => {
    if (search && onClick) {
      onClick(inputRef.current.value);
    }
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Paper
        component="div"
        sx={{
          p: "2px ",
          display: "flex",
          alignItems: "center",
          width: "100%",
        }}
      >
        <InputBase
          sx={{ ml: 1, flex: 1 }}
          placeholder={placeholder}
          type="search"
          value={value}
          onChange={onChange}
          onKeyDown={onKeyDown}
          inputRef={inputRef}
          inputProps={{ "aria-label": placeholder, disabled }}
        />
        <IconButton
          type="button"
          sx={{ p: "5px" }}
          aria-label="search"
          onClick={handleClick}
        >
          <SearchIcon />
        </IconButton>
      </Paper>
    </Box>
  );
}

export default SearchInput;
